export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=template&id=029161d9"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Dashboard.vue?vue&type=template&id=029161d9
// module id = 2286
// module chunks = 31